import React, {Component} from "react";
import './App.css';
import LoginForm from "./LoginForm";
import ManifestList from "./ManifestList";
import Manifest from "./Manifest";
import Storage from "./Storage";
import {BrowserRouter, Link, Route, Switch} from 'react-router-dom';
import Container from "react-bootstrap/Container";
import Package from "./Package";
import Search from "./Search";
import Billing from "./Billing";
import BillingUPS from "./BillingUPS";
import UPSInvoice from "./UPSInvoice";
import UPSInvoiceUser from "./UPSInvoiceUser";
import BillingUPSMI from "./BillingUPSMI";
import BillingUSPS from "./BillingUSPS";
import Report from "./Report";
import BillingFedEx from "./BillingFedEx";
import FEDEXInvoice from "./FEDEXInvoice";
import BillingUPSMICA from "./BillingUPSMICA";
import BillingTUSAS from "./BillingTUSAS";
import BillingOnTrac from "./BillingOnTrac";
import OnTracInvoice from "./OnTracInvoice";
import DHLManifestList from "./DHLManifestList";
import DHLManifestCreate from "./DHLManifestCreate";
import SpeedXManifestList from "./SpeedXManifestList";
import SpeedXManifestCreate from "./SpeedXManifestCreate";
import UPSAdultRelabel from "./UPSAdultRelabel";
import CarrierSelection from "./CarrierSelection";

const frontendVersion = '2021-11-24.1';

export default class App extends Component {
    render() {
        if (!Storage.getToken()) {
            return <LoginForm/>
        }

        return (
            <BrowserRouter>
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <Container>
                        <button className="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="manifestsDropdown" role="button"
                                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Manifests
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="manifestsDropdown">
                                        <Link to="/" className="dropdown-item">Velox</Link>
                                        <Link to="/dhl-manifests" className="dropdown-item">DHL</Link>
                                        <Link to="/speedx-manifests" className="dropdown-item">SpeedX</Link>
                                    </div>
                                </li>
                                {/*<li className="nav-item">*/}
                                {/*    <Link to="/vip-rates" className="nav-link">VIP Rates</Link>*/}
                                {/*</li>*/}
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="toolsDropdown" role="button"
                                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Tools
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="toolsDropdown">
                                        <Link to="/report" className="dropdown-item">Report</Link>
                                        <Link to="/ups-adult-relabel" className="dropdown-item">UPS Relabel</Link>
                                        <Link to="/carrier-selection" className="dropdown-item">Carrier selection</Link>
                                    </div>
                                </li>
                                {/*<li className="nav-item">*/}
                                {/*    <Link to="/vipparcel-packages" className="nav-link">Vipparcel Packages</Link>*/}
                                {/*</li>*/}
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Billing
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <Link to="/billing-ups" className="dropdown-item">UPS</Link>
                                        <Link to="/billing-upsmi" className="dropdown-item">UPS MI</Link>
                                        <Link to="/billing-fedex" className="dropdown-item">FEDEX</Link>
                                        <Link to="/billing-usps" className="dropdown-item">USPS</Link>
                                        <Link to="/billing-upsmi-ca" className="dropdown-item">UPS MI (CA/MX)</Link>
                                        <Link to="/billing-tusas-ups" className="dropdown-item">TUSAS UPS</Link>
                                        <Link to="/billing-ontrac" className="dropdown-item">ONTRAC</Link>
                                    </div>
                                </li>
                            </ul>
                            <Route component={Search}/>
                        </div>
                    </Container>
                </nav>
                <Switch>
                    <Route path="/manifests/:id" component={Manifest}/>
                    <Route path="/billing" component={Billing}/>
                    <Route path="/packages/:trackingNumberOrHawb" component={Package}/>
                    {/*<Route path="/vipparcel-packages" component={VipparcelPackages}/>*/}
                    {/*<Route path="/vip-rates" component={VipparcelRates}/>*/}
                    <Route path="/ups-invoices/:invoiceNumber/users/:user" component={UPSInvoiceUser}/>
                    <Route path="/ups-invoices/:invoiceNumber" component={UPSInvoice}/>
                    <Route path="/ontrac-invoices/:invoiceNumber" component={OnTracInvoice}/>
                    <Route path="/fedex-invoices/:invoiceNumber" component={FEDEXInvoice}/>
                    <Route path="/billing-ups" component={BillingUPS}/>
                    <Route path="/billing-upsmi" component={BillingUPSMI}/>
                    <Route path="/billing-fedex" component={BillingFedEx}/>
                    <Route path="/billing-usps" component={BillingUSPS}/>
                    <Route path="/billing-upsmi-ca" component={BillingUPSMICA}/>
                    <Route path="/billing-tusas-ups" component={BillingTUSAS}/>
                    <Route path="/billing-ontrac" component={BillingOnTrac}/>
                    <Route path="/report" component={Report}/>
                    {/* before /:refOrMAWB, it would match /dhl-manifests and /speedx-manifests */}
                    <Route exact path="/dhl-manifests/new" component={DHLManifestCreate}/>
                    <Route exact path="/dhl-manifests" component={DHLManifestList}/>
                    <Route exact path="/speedx-manifests/new" component={SpeedXManifestCreate}/>
                    <Route exact path="/speedx-manifests" component={SpeedXManifestList}/>
                    <Route exact path="/ups-adult-relabel" component={UPSAdultRelabel}/>
                    <Route exact path="/carrier-selection" component={CarrierSelection}/>
                    <Route exact path="/:refOrMAWB" component={ManifestList}/>
                    <Route exact path="/" render={(props) => <ManifestList {...props} key={Date.now()}/>}/>
                </Switch>
                <Container>
                    <hr/>
                    <footer>
                        <ul className="float-right">
                            <li>
                                Frontend version: {frontendVersion}
                            </li>
                            {/*<li>*/}
                            {/*    Backend version:*/}
                            {/*</li>*/}
                        </ul>
                    </footer>
                </Container>
            </BrowserRouter>
        );
    }
}
